import axios from 'axios'
import { getToken } from './API'
import { API } from '@/mixins/constants'

const oauthInstance = axios.create({
  baseURL: process.env.VUE_APP_ONWHEEL_UTILS_API_URL,
  timeout: 30000
})

const oauthPost = (uri, params, withToken = true) => {
  const headers = { 'Content-Type': 'application/json' }
  if (withToken) {
    const token = getToken()
    headers.Authorization = `Bearer ${token}`
  }
  return oauthInstance.post(uri, params, { headers }).then((res) => res.data)
}

export const validateAuthRequest = (params) => {
  return oauthPost(API.oauth.validate, params, true)
}

export const checkGrant = (params) => {
  return oauthPost(API.oauth.grant_status, params, true)
}

export const issueAuthCode = (params) => {
  return oauthPost(API.oauth.issue, params, true)
}
